// extracted by mini-css-extract-plugin
export default {"container":"mlX8RQTikC8Gv8JXk7_d","label":"NrhgZhF0Kgq4pZWiQusR","description":"WGMax0eFuEBvBckQbipQ","termsContainer":"IPh4UjLKAOEVt8wVtyws","pulse":"sDqowCCGlCFMukN_zojX"};